import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import de from "./locales/de.json";

// 🌍 gespeicherte Sprache aus dem Browser laden
const savedLocale = localStorage.getItem("locale");

const i18n = createI18n({
  legacy: true,                 // wichtig für this.$i18n in deinen Components
  locale: savedLocale || "de",  // 🔥 hier wird sie gesetzt
  fallbackLocale: "en",
  messages: { en, de },
});

export default i18n;